import { useState, useEffect, useRef, useContext } from "react";
import { NavLink } from "react-router-dom";
import { StoreContext } from "../../context/StoreContext";
import "./AdminNav.css"

import logo from "../../assets/logoo.png";

const NAV_ITEMS = [
    { label: "Dashboard", href: "/admin/dashboard" },
    { label: "Insights", href: "/admin/insights" },
    { label: "Applications", href: "/admin/applications" },
    { label: "Downloads", href: "/admin/downloads" },
    { label: "Scores", href: "/admin/assessment" },
    { label: "Contacts", href: "/admin/contact-forms" },
];

export default function AdminNav() {

    const { logout } = useContext(StoreContext);

    const [scrolled, setScrolled] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);

    const navRef = useRef(null);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 10);

        window.addEventListener("scroll", onScroll, {
            passive: true,
        });

        return () =>
            window.removeEventListener("scroll", onScroll);
    }, []);

    // Close on outside click
    useEffect(() => {

        const onOutside = (e) => {
            if (
                navRef.current &&
                !navRef.current.contains(e.target)
            ) {
                setMobileOpen(false);
            }
        };

        document.addEventListener(
            "mousedown",
            onOutside
        );

        return () =>
            document.removeEventListener(
                "mousedown",
                onOutside
            );

    }, []);

    return (

        <nav
            ref={navRef}
            className={`br-nav${scrolled
                ? " br-nav--scrolled"
                : ""
                }`}
            aria-label="Main navigation"
        >

            <div className="br-nav__inner">

                {/* ── Logo ── */}

                <NavLink
                    to="/"
                    className="br-nav__logo"
                    aria-label="BaiRees Global Advisory"
                >

                    <span className="br-nav__logo-mark">
                        <img
                            src={logo}
                            alt=""
                            className="br-nav__logo-img"
                        />
                    </span>

                    <span className="br-nav__logo-text">

                        <span className="br-nav__logo-name">
                            BAIREES
                        </span>

                        <span className="br-nav__logo-sub">
                            GLOBAL ADVISORY
                        </span>

                    </span>

                </NavLink>

                {/* ── Desktop links ── */}

                <ul
                    className="br-nav__links"
                    role="menubar"
                >

                    {NAV_ITEMS.map((item) => (

                        <li
                            key={item.label}
                            role="none"
                            className="br-nav__item"
                        //   className="br-nav__item--active"

                        >


                            <NavLink
                                to={item.href}
                            >
                                <button className="br-nav__link">
                                    {item.label}
                                </button>

                            </NavLink>

                        </li>

                    ))}

                </ul>

                {/* ── CTA ── */}

                <button
                    onClick={logout}
                    className="br-nav__cta"
                >
                    Logout
                </button>

                {/* ── Hamburger ── */}

                <button
                    className={`br-nav__hamburger${mobileOpen
                        ? " br-nav__hamburger--open"
                        : ""
                        }`}
                    onClick={() =>
                        setMobileOpen(!mobileOpen)
                    }
                    aria-label={
                        mobileOpen
                            ? "Close menu"
                            : "Open menu"
                    }
                    aria-expanded={mobileOpen}
                >

                    <span />
                    <span />
                    <span />

                </button>

            </div>

            {/* ── Mobile drawer ── */}

            <div
                className={`br-nav__mobile${mobileOpen
                    ? " br-nav__mobile--open"
                    : ""
                    }`}
                aria-hidden={!mobileOpen}
            >

                <div className="br-nav__mobile-scroll">

                    {NAV_ITEMS.map((item) => (

                        <div
                            key={item.label}
                            className="br-nav__mobile-section"
                        >

                            <NavLink
                                to={item.href}
                                onClick={() =>
                                    setMobileOpen(false)
                                }
                            >

                                <button className="br-nav__mobile-toggle">

                                    {item.label}

                                    <svg
                                        className="br-nav__chevron"
                                        width="10"
                                        height="6"
                                        viewBox="0 0 10 6"
                                        fill="none"
                                    >

                                        <path
                                            d="M1 1l4 4 4-4"
                                            stroke="currentColor"
                                            strokeWidth="1.6"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />

                                    </svg>

                                </button>

                            </NavLink>

                        </div>

                    ))}

                    <div
                        onClick={logout}
                        className="br-nav__mobile-cta-wrap"
                    >
                        Logout
                    </div>

                </div>

            </div>

        </nav>
    );
}